import React, {Component} from "react";
import Nav from '../../components/nav/Nav';
import {bindActionCreators} from "redux";

import {connect} from "react-redux";
import SignatureCanvas from 'react-signature-canvas'

import {
    Alert,
    Modal,
    ModalBody,
    ModalHeader,
    ModalFooter,
    Button,
    Col,
    Row
} from 'reactstrap';

import {
    getForm,
    postForm,
    postFormResponse
} from '../../actions/checklist';

import {
    getForm as getFormService,
    postForm as postFormService
} from '../../services/checklist';

import $ from "jquery";

import Spinner from '../../components/spinner/Spinner';
import env from "../../env";
import {getStoredData, removeDataFromStorage, storeData} from "../../Helpers";

class Form  extends Component{

    constructor(){
        super();
        this.state = {
            creating: false,
            created: false,
            loading: true,
            form: null,
            error: null,
            notes: {},
            raise_ci_task: {},
            requestSignature: true,
            signature: null,
            canSign: false,
            formData: null,
            cmsModal : false,
            showCMSModal: true,
        };

        this.submitForm = this.submitForm.bind(this);
    }

    signaturePad = {};

    componentWillReceiveProps(nextProps){

        const {creating, created, form, error, loading} = nextProps.checklists;

        this.setState({
            creating,
            created,
            form,
            error,
            loading
        });

        let elements = 0;

        if (form && !error){
            const savedData = getStoredData('checklists');
            const data = savedData ? JSON.parse(savedData)[this.getStorageKey()]: null;
            let notes = {};
            let raise_ci_task = {};

            if (data) {
                notes = data.data.notes || {};
                raise_ci_task = data.data.raise_ci_task || {};
                this.setState({
                    notes,
                    raise_ci_task,
                })
            }

            $('.form-holder').html(form);
            $('.form-holder').find('.ajax-file-upload-new').each(function(){
                $(this).attr('data-url',`${env.base_url}api/1.0/ajax/upload?multiple=true`);
            });
            const cmsModal = $('.form-holder').find('#select_cms');
            elements = $(cmsModal).find("#cms_selected_body .radio");

            $('#cms-content').html($(cmsModal).find("#cms_selected_body"));
            $('#cms-content-header').html($(cmsModal).find(".modal-header"));
            $('#cms-content-footer').html($(cmsModal).find(".modal-footer"));

            for (let item in notes){
                if (notes.hasOwnProperty(item)){
                    $('.form-holder').find(`textarea[name=${item}]`).val(notes[item]);
                }
            }

            for (let i in raise_ci_task) {
                if (raise_ci_task.hasOwnProperty(i)){
                    const inputs = $('.form-holder').find(`input[name=${i}]`);
                    if (inputs.length){
                        for (let j = 0; j < inputs.length; j++){
                            if ($(inputs[j]).val() === raise_ci_task[i]){
                                $(inputs[j]).prop('checked', true);
                            }
                        }
                    }
                }
            }
            this.initUpload();

            this.setState({
                cmsModal: elements.length > 0,
                showCMSModal: elements.length > 0,
            })
        }

        if(error){
            window.scrollTo(0, 0);
        }

    }

    closeModal = () =>{
        this.setState({
            created: false
        });

        this.props.history.push(`${env.url}/checklists/list/`);
    };

    gotToList = () => {
        this.props.history.push(`${env.url}/checklists/list/`);
    };

    componentDidMount(){
        const {loggedIn} = this.props.account;

        if(!loggedIn){
            this.props.history.push(`${env.url}/login`);
        }

        const id = this.props.match.params[0];

        if(!id || isNaN(id))
            this.props.history.push(`${env.url}/checklists/list/`);


        let props = this.props;

        const data = getStoredData('checklists');
        const savedData = data ? JSON.parse(data)[this.getStorageKey()]: null;

        if (savedData) {
            props.getForm(savedData.html);
        }else {
            getFormService({id}).then(function(resp){
                props.getForm(resp);
            }).catch(function(e){
                console.log(e);
            });
        }

         this.initJQuery();
    }

    saveChecklist = (html) => {
        const key = this.getStorageKey();
        const data = {
            notes: this.state.notes,
            raise_ci_task: this.state.raise_ci_task,
        };

        let existingData = getStoredData('checklists');
        if (existingData){
            existingData = JSON.parse(existingData);
        }else{
            existingData = {};
        }
        existingData[key] = {html, data};

        storeData('checklists', JSON.stringify(existingData));
        this.gotToList();
    };

    getStorageKey = () => {
        const id = this.props.match.params[0];
        return `checklist_${id}`;
    };

    setFormData = (formData) => {
        if(formData){
            if (this.state.requestSignature){
                this.setState({
                    formData,
                    canSign: true,
                })
            }else {
                this.submitForm(formData);
            }

        }else{
            this.setState({ error : 'Please use Chrome Browser or a most recent version of your preferred browser!'});
        }
    };

    submitForm(data, signature){

        let formData = data? data: this.state.formData;

        if(formData){
            let props = this.props;

            if (signature){
                formData.append('signature', signature);
            }

            props.postForm();

            let savedData = getStoredData('checklists');
            if (savedData){
                savedData = JSON.parse(savedData);
            }else{
                savedData = {};
            }

            if (savedData[this.getStorageKey()]){
                delete savedData[this.getStorageKey()];
            }

            if (Object.keys(savedData).length){
                storeData('checklists', JSON.stringify(savedData));
            } else {
                removeDataFromStorage('checklists');
            }

            postFormService(formData).then(function(resp){
                props.postFormResponse(resp);
            }).catch(function(e){
                console.log(e);
            })

        }else{
            this.setState({ error : 'Please use Chrome Browser or a most recent version of your preferred browser!'});
        }
    }

    returnToForm = () => {
        this.setState({
            canSign: false,
        })
    };

    initUpload()
    {
        function initFileUploadInput()
        {
            let submit = $('.checklist-form').find('button#save-checklist');

            $('.ajax-file-upload-new').fileupload({
                dataType: 'json',
                replaceFileInput: false,
                singleFileUploads: false,
                progress: function (e, data) {
                    let progress = parseInt(data.loaded / data.total * 100, 10) - 1;
                    let parent = $(e.target).parents('td');
                    let progressBar = $(parent).find('.progress .progress-bar');
                    $(progressBar).css(
                        'width',
                        progress + '%'
                    );

                    $(submit).attr('disabled', true);
                    $(progressBar).find('span').text(progress+'%');
                },
                done: function (e, data) {
                    let parent = $(e.target).parents('td');
                    let progressBar = $(parent).find('.progress .progress-bar');
                    $(progressBar).css(
                        'width',
                        '100%'
                    );
                    const holder = $(parent).find('span.uploaded-files');
                    let uploads = '';
                    let labels = '<span class="uploaded-files" style="display: inline-block;font-size: 10px;width: 100%;text-align: left;color: green;">';

                    for (let i in data.originalFiles){
                        if (data.originalFiles.hasOwnProperty(i)){
                            uploads += `<span>Uploaded: ${data.originalFiles[i].name} <a data-name="${data.originalFiles[i].name}" class="remove-file" style="color: red;padding: 5px;z-index: 100;cursor: pointer;">X</a></span><br/>`;
                        }
                    }

                    labels += uploads;
                    labels += '<span>';

                    let input = $(parent).find('input[type="file"]');


                    if (holder.length){
                        $(holder).append(uploads);
                    }else {
                        $(input).before(labels);
                    }

                    $(progressBar).find('span').text('100%');

                    const inputFile = $(parent).find('.ajax-file-upload-new-url');
                    let val = $(inputFile).val();
                    let result = data.result.data.url.join(',');
                    if (val){
                        result = `${val},${result}`;
                    }
                    $(inputFile).val(result);

                    let enable = true;

                    $('#checklists_table').find('.progress .progress-bar span').each(function(){
                        var val = $(this).text();
                        if(val && val !== '100%'){
                            enable = false;
                        }
                    });

                    if(enable){
                        $(submit).removeAttr('disabled');
                    }
                }
            }).bind('fileuploadsubmit', function (e, data) {
                data.formData = {
                    'mine_id': $('input[name="mine_id"]').val(),
                };
            });
        }

        initFileUploadInput();
    }

    updateNotes = (name, note) => {
        this.setState({
            notes: {...this.state.notes, [name]: note},
        })
    };

    updateRaiseCITask = (name, value) => {
        this.setState({
            raise_ci_task: {...this.state.raise_ci_task, [name]: value},
        })
    };

    initJQuery(){

        let submit = this.setFormData;
        let list = this.gotToList;
        let saveChecklist = this.saveChecklist;
        let updateNotes = this.updateNotes;
        let updateRaiseCITask = this.updateRaiseCITask;
        let closeCMSModal = this.hideCMSModal;

        $(document).ready(function(){

            $(document).on('click',  '#cms_selected button', function(e){
                closeCMSModal();
            });

            $(document).on('change', 'input[type=radio][name=cms-to-be-completed]', function() {
                $('#cms_to_complete').val($(this).val());
            });

            $('.form-holder').on('keyup', 'textarea', function(e){
                updateNotes(e.target.name, e.target.value);
            });

            $('.form-holder').on('change', 'input.raise-ci-task', function(e){
                updateRaiseCITask(e.target.name, e.target.value);
            });

            $('.form-holder').on('click', '.remove-file', function(e){
                e.preventDefault();

                const name = $(this).attr('data-name');
                const parent = $(this).parents('td');
                const input = $(parent).find('.ajax-file-upload-new-url');
                const files =  $(input).val();
                let newValue = '';

                const filesArray = files.split(',');
                if (filesArray && filesArray.length){
                    filesArray.forEach(file => {
                        if (file.indexOf(`_${name.toLowerCase()}`) < 0){
                            newValue = newValue ? `${newValue},${file}`: file;
                        }
                    });
                }

                if (newValue){
                    $(input).val(newValue);
                }else{
                    $(input).removeAttr('value');
                }

                $(this).parent().remove();

            });

            $('.form-holder').on('click', '#save-only', function(e) {
                e.preventDefault();
                e.stopPropagation();
                saveChecklist($('.form-holder').html());
            });

            $('.form-holder').on('click','.btn-info', function(e){
                e.stopPropagation();
                e.preventDefault();

                let href = $(this).attr('href');
                let index = href.indexOf('(');

                let id = href.substring(index + 1, href.length - 2);

                if(!isNaN(parseInt(id))){
                    let parent = $(this).parents('tbody');
                    let div = parent.find('#notes_holder_'+id);

                    let visibility = $(div).is(':visible');

                    if(visibility)
                        $(div).hide();
                    else
                        $(div).show()

                }
            });


            $('.form-holder').on('click', 'a[data-original-title="Mark Completed"]', function(e){

                e.stopPropagation();
                e.preventDefault();

                let img = $(this).find('img');

                let tick = 'task_ticked.jpg';
                let untick = 'task_unticked.jpg';

                let current = $(img).attr('src');


                let index = current.lastIndexOf('/') + 1;
                let http = current.substring(0, index);

                current = current.substring(index, current.length);

                let href = $(this).attr('href');
                index = href.indexOf('(');

                let id = href.substring(index + 2, href.length - 3);
                id = `input#is_completed_${id}`;

                let input = $(this).parents('tr').find(id);

                if(current === tick){
                    $(this).find('img').attr('src', `${http}${untick}`);
                    $(input).val(0);
                }
                else{
                    $(this).find('img').attr('src', `${http}${tick}`);
                    $(input).val(1);
                }


            });

            $('.form-holder').on('submit', '.form-horizontal', function(e){

                e.preventDefault();

                let form = $(this)[0];
                let formData = false;

                //Fix issue with Safari when file is empty
                for (let i = 0; i < form.elements.length; i++) {
                    if (form.elements[i].type === 'file') {
                        if (form.elements[i].value === '') {
                            form.elements[i].parentNode.removeChild(form.elements[i]);
                        }
                    }
                }

                if (window.FormData){
                    formData = new FormData(form);

                }

                submit(formData);
            });

            $('.form-holder').on('click', 'a[href="checklist?section=ction=view"]', function(e){
                e.stopPropagation();
                e.preventDefault();

                list();
            });

        });



    }

    clearSignaturePad = () => {
        this.signaturePad.clear()
    };

    saveSignature = () => {
        const signature = this.signaturePad.getTrimmedCanvas()
            .toDataURL('image/png');
        this.setState({signature});

        if (signature === 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAAtJREFUGFdjYAACAAAFAAGq1chRAAAAAElFTkSuQmCC')
            return;

        this.submitForm(this.state.formData, signature)
    };

    hideCMSModal = () => {
        this.setState({
            showCMSModal: false,
        })
    };

    render(){

        const {
            creating,
            loading,
            error,
            created,
            requestSignature,
            canSign,
            cmsModal,
            showCMSModal
        } = this.state;

        const formStyle = (requestSignature && !canSign) || !requestSignature ? {display: 'block'}: {display: 'none'};

        return(
            <div className="checklists-form">

                {
                    creating?
                        <Spinner
                            message="Submitting checklist"
                            overlay={true}/>:null
                }

                <Nav
                    location={this.props.location}
                    history={this.props.history}/>

                {
                    loading?
                        (
                            <Spinner/>

                        ):
                        (
                            error?
                                <Alert color="danger">{error}</Alert>
                                :
                                null
                        )

                }

                <div className="form-holder" style={formStyle}/>

                {
                    requestSignature && canSign ?
                        <div className="signature-pad" style={{
                            marginBottom: '25px',
                        }}>
                            <h6 style={{
                                textAlign: 'center',
                                marginTop: '15px',
                            }}>Please sign in the box below</h6>
                            <SignatureCanvas
                                clearOnResize={true}
                                penColor='green'
                                ref={(ref) => { this.signaturePad = ref }}
                                canvasProps={{width: 350, height: 200, className: 'sigCanvas', style: {
                                        backgroundColor: '#fff',
                                        marginLeft: 'auto',
                                        marginRight: 'auto',
                                        display: 'block',
                                    }}} />
                            <div className="buttons" style={{
                                maxWidth: '350px',
                                margin: '10px auto',
                            }}>
                                <Row>
                                    <Col>
                                        <Button
                                            onClick={this.returnToForm}
                                            className="btn btn-default">
                                            Back
                                        </Button>
                                    </Col>
                                    <Col style={{textAlign: 'center'}}>
                                        <Button
                                            onClick={this.clearSignaturePad}
                                            className="btn btn-warning">
                                            Clear
                                        </Button>
                                    </Col>
                                    <Col style={{textAlign: 'center'}}>
                                        <Button
                                            onClick={this.saveSignature}
                                            className="btn btn-success">
                                            Done
                                        </Button>
                                    </Col>
                                    <Col style={{textAlign: 'right'}}>
                                        <Button
                                            onClick={() => this.submitForm()}
                                            className="btn btn-info">
                                            Skip
                                        </Button>
                                    </Col>
                                </Row>
                            </div>
                        </div>: null
                }

                <Modal
                    isOpen={created}
                    toggle={this.closeModal}
                    className={this.props.className}>

                    <ModalHeader toggle={this.toggle}>CheckList Completed</ModalHeader>

                    <ModalBody>
                        CheckList has been successfully completed!
                    </ModalBody>

                    <ModalFooter>
                        <Button color="primary" onClick={this.closeModal}>Ok</Button>
                    </ModalFooter>
                </Modal>

                <Modal
                    zIndex={cmsModal && !(created || creating || error)? 10000: -1}
                    backdrop="static"
                    isOpen={showCMSModal && !(created || creating || error)}
                    toggle={this.hideCMSModal}
                    className={this.props.className}>
                    <ModalHeader>
                        <div id="cms-content-header"></div>
                    </ModalHeader>
                    <ModalBody>
                        <div id="cms-content"></div>
                    </ModalBody>
                    <ModalFooter>
                        <div id="cms-content-footer"></div>
                    </ModalFooter>
                </Modal>

            </div>
        )
    }
}


const mapStateToProps = ({ account, checklists}) => ({
    account,
    checklists
});

const mapDispatchToProps = dispatch => bindActionCreators({
    getForm : (response) => getForm(response),
    postForm : () => postForm(),
    postFormResponse : (resp) => postFormResponse(resp)
}, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Form)



// WEBPACK FOOTER //
// ./src/screens/checklists/Form.js